import React from 'react'
import { HudsonSidebarDemo } from '../components/ui/hudson-sidebar'

const SidebarDemoPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-neutral-900 p-4">
      <div className="mb-8 text-center">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
          Member Portal - Sidebar Navigation
        </h1>
        <p className="text-gray-600 dark:text-gray-400">
          Hover over the sidebar to expand. Perfect for member dashboards and admin panels.
        </p>
      </div>
      <HudsonSidebarDemo />
    </div>
  )
}

export default SidebarDemoPage 